import { render, staticRenderFns } from "./MainTemplateHeader.vue?vue&type=template&id=1a750440&"
import script from "./MainTemplateHeader.vue?vue&type=script&lang=js&"
export * from "./MainTemplateHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports